module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc37-22b87930d0191e10de1e02705b568ede.jpg";